/* spinner.tsx generated by @compiled/babel-plugin v0.37.1 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=%40media%20screen%20and%20(forced-colors%3Aactive)%7B._jcxd7g3v%7Bfilter%3Agrayscale(100%25)%7D._1tjm1onz%7Bstroke%3ACanvasText%7D%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1snbbs82%7Bstroke-width%3A1.5%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._7ljx1dhp%7Bstroke-dasharray%3A60%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._lswuglyw%7Bfill%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._s7n4nkob%7Bvertical-align%3Amiddle%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1e0c116y%7Bdisplay%3Ainline-flex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1o51q7pw%7Banimation-fill-mode%3Aforwards%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1pgl1ytf%7Banimation-timing-function%3Aease-in-out%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._5sag9cwz%7Banimation-duration%3A1s%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._j7hq1ky6%7Banimation-name%3Ak1v8un7d%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=%40keyframes%20k1v8un7d%7B0%25%7Btransform%3Arotate(50deg)%3Bstroke-dashoffset%3A60%7Dto%7Btransform%3Arotate(230deg)%3Bstroke-dashoffset%3A50%7D%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._8hrz1h6o%7Btransform-origin%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1pgl2qsq%7Banimation-timing-function%3Acubic-bezier(.4%2C.15%2C.6%2C.85)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._tip812c5%7Banimation-iteration-count%3Ainfinite%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._5sag12kz%7Banimation-duration%3A.86s%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._j7hqsf8s%7Banimation-name%3Akztt5h0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=%40keyframes%20kztt5h0%7Bto%7Btransform%3Arotate(1turn)%7D%7D");
import React, { useContext, useEffect, useLayoutEffect as useRealLayoutEffect } from 'react';
import InteractionContext from '@atlaskit/interaction-context';
import { N0, N500 } from '@atlaskit/theme/colors';
import { presetSizes } from './constants';
import { type Appearance, type SpinnerProps } from './types';

/**
 * Returns the appropriate circle stroke color.
 */
function getStrokeColor(appearance: Appearance): string {
  return appearance === 'inherit' ? `var(--ds-icon-subtle, ${N500})` : `var(--ds-icon-inverse, ${N0})`;
}
const rotate = null;

/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */
const loadIn = null;
const styles = {
  rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
  loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o51q7pw",
  wrapperStyles: "_1e0c116y _s7n4nkob",
  circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};

/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */
const useLayoutEffect = typeof window === 'undefined' ? useEffect : useRealLayoutEffect;

/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */
const Spinner: React.MemoExoticComponent<React.ForwardRefExoticComponent<SpinnerProps & React.RefAttributes<SVGSVGElement>>> = React.memo(React.forwardRef<SVGSVGElement, SpinnerProps>(function Spinner({
  appearance = 'inherit',
  delay = 0,
  interactionName,
  label,
  size: providedSize = 'medium',
  testId
}: SpinnerProps, ref) {
  const size: number = typeof providedSize === 'number' ? providedSize : presetSizes[providedSize];
  const animationDelay = `${delay}ms`;
  const stroke = getStrokeColor(appearance);
  const context = useContext(InteractionContext);
  useLayoutEffect(() => {
    if (context != null) {
      return context.hold(interactionName);
    }
  }, [context, interactionName]);

  /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */
  return <span
  /**
   * This span exists to off-load animations from the circle element,
   * which were causing performance issues (style recalculations)
   * on Safari and older versions of Chrome.
   *
   * This can be removed and styles placed back on the circle element once
   * Safari fixes this bug and off-loads rendering to the GPU from the CPU.
   */ data-testid={testId ? `${testId}-wrapper` : 'spinner-wrapper'}
  // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
  style={{
    animationDelay,
    width: size,
    height: size
  }} className={ax([styles.wrapperStyles, styles.rotateStyles])}>
				<svg height={size} width={size} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" data-testid={testId} ref={ref} aria-label={label || undefined}
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    style={{
      animationDelay
    }} role={label ? 'img' : 'none'} className={ax([styles.loadInStyles])}>
					<circle cx="8" cy="8" r="7" style={{
        stroke
      }} className={ax([styles.circleStyles])} />
				</svg>
			</span>;
}));
export default Spinner;